import { render } from "./HeaderTabs.vue?vue&type=template&id=4a3577a7&scoped=true"
import script from "./HeaderTabs.vue?vue&type=script&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&lang=js"

import "./HeaderTabs.vue?vue&type=style&index=0&id=4a3577a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3577a7"]])

export default __exports__